import { Api } from '../api';
import { card } from '../endpoints';
import type { CardEntity, CardSearchParams } from './models';

export class CardApi extends Api {
  static getCardsByAccount = (accountId: string, signal?: AbortSignal) => this.get<CardEntity[]>({ url: card.getAccount(accountId), signal });

  static activateCard = (cardId: string, signal?: AbortSignal) => this.post<CardSearchParams, CardEntity[]>({ url: card.activation(cardId), signal });

  static replaceCard = (cardId: string, signal?: AbortSignal) => this.post<CardSearchParams, CardEntity[]>({ url: card.replaceCard(cardId), signal });

  static reprintPin = (cardId: string, signal?: AbortSignal) => this.post<CardSearchParams, CardEntity[]>({ url: card.reprintPin(cardId), signal });

  static blockCard = (cardId: string, signal?: AbortSignal) => this.put<CardSearchParams, CardEntity[]>({ url: card.blockCard(cardId), signal });

  static unblockCard = (cardId: string, signal?: AbortSignal) => this.put<CardSearchParams, CardEntity[]>({ url: card.unblockCard(cardId), signal });
}
